import React from 'react';
import Logo from '../../assets/logos/Logo';
import { GearIcon, LogoutIcon, ExpandIcon } from '../../icons';
import ThemeToggle from '../ui/ThemeToggle';

interface NavbarProps {
  currentTheme: 'light' | 'dark';
  onThemeToggle: () => void;
  onOpenPreferences: () => void;
  onLogout: () => void;
  onToggleFilesSidebar?: () => void;
  onToggleToolsSidebar?: () => void;
}

const Navbar: React.FC<NavbarProps> = ({
  currentTheme,
  onThemeToggle,
  onOpenPreferences,
  onLogout,
  onToggleFilesSidebar,
  onToggleToolsSidebar,
}) => {
  return (
    <nav className="bg-white dark:bg-gray-800 shadow-sm border-b border-gray-200 dark:border-gray-700">
      <div className="px-3 sm:px-6 py-2">
        <div className="flex justify-between items-center">
          <div className="flex items-center space-x-2">
            {/* Mobile Files Menu Button */}
            {onToggleFilesSidebar && (
              <button
                onClick={onToggleFilesSidebar}
                className="md:hidden p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
                title="Toggle files sidebar"
                aria-label="Toggle files sidebar"
              >
                <ExpandIcon
                  size={20}
                  className="text-gray-600 dark:text-gray-300"
                />
              </button>
            )}
            <Logo className="h-6 sm:h-8 w-auto" />
          </div>

          <div className="flex items-center space-x-2 sm:space-x-4">
            {/* Mobile Tools Menu Button */}
            {onToggleToolsSidebar && (
              <button
                onClick={onToggleToolsSidebar}
                className="md:hidden p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
                title="Toggle tools sidebar"
                aria-label="Toggle tools sidebar"
              >
                <ExpandIcon
                  size={20}
                  className="text-gray-600 dark:text-gray-300 scale-x-[-1]"
                />
              </button>
            )}
            {(process.env.REACT_APP_TRANSCRIBING_SERVICE_SELECTION === 'true' ||
              process.env.REACT_APP_UTTERANCE_META_COLUMN_SELECTION ===
                'true' ||
              process.env.REACT_APP_DEBUG_TUTORIALS_RESET === 'true') && (
              <button
                onClick={onOpenPreferences}
                className="p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
                title="Change preferences"
                aria-label="Change preferences"
              >
                <GearIcon
                  size={20}
                  className="text-gray-600 dark:text-gray-300"
                />
              </button>
            )}
            <ThemeToggle currentTheme={currentTheme} onToggle={onThemeToggle} />
            <button
              onClick={onLogout}
              className="p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
              title="Logout"
              aria-label="Logout"
            >
              <LogoutIcon
                size={20}
                className="text-gray-600 dark:text-gray-300"
              />
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
